import { LoadableChangePersonalData } from "features";
import React from "react";
import { Breadcrumb } from "shared/ui/components";

export default function ChangePersonalDataPage() {
  return (
    <>
      <Breadcrumb preCrumb={{ text: "profile", link: "/profile" }} />
      <LoadableChangePersonalData />
    </>
  );
}
